import { Avatar, Box, Button, Grid, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { deepOrange } from "@mui/material/colors";
import { Suspense, lazy, useContext, useState } from "react";
import { ArrowRight } from "react-iconly";
import { Translate } from "src/assets/data/index";
import TrackingCard from "src/components/ui/TrackingCard";
import EditIcon from "src/components/ui/svgIcon/EditIcon";
import MedicalCallIcon from "src/components/ui/svgIcon/MedicalCallIcon";
import { UserContext } from "src/contexts/UserContext";
import { MenuContext } from "src/contexts/menu-context/MenuContext";
import useLogout from "src/layouts/AVC_Main/services/sidebarDashboard/systemSection/useLogout";
import { v4 as uuidv4 } from "uuid";

const BioMenu = (props) => {
  const { menu, handleClose } = props;
  const theme = useTheme();

  let [selectedItem, setSelectedItem] = useState("");
  let Icon;
  let ComponentSelected;

  const rundomId = uuidv4();

  const { performLogout, loading } = useLogout();
  const { addToNewTab, setTab, setNewTabItems, setNewTabContent, setSelectedTab } = useContext(MenuContext);
  const { realLegal, thumbnailUrl, name, lastName } = useContext(UserContext);

  const [userProfileData, setUserProfileData] = useState({
    firstName: name,
    lastName: lastName,
    thumbnail_url: thumbnailUrl,
  });

  const onItemClick = (node) => {
    if (node.codeInWeb === "performLogout") {
      performLogout();
    }
    if (node.codeInWeb === "Home") {
      setNewTabItems([]);
      setNewTabContent([]);
      handleClose();
    } else {
      setSelectedItem(node);
    }
  };

  const onClose = () => {
    setSelectedItem(null);
  };

  return (
    <Stack alignItems="center" justifyContent="center" height="100%" width="100%">
      {!selectedItem?.id ? (
        <Stack alignItems="center" spacing={1} m={1}>
          <Avatar src={userProfileData?.thumbnail_url} sx={{ width: 56, height: 56, bgcolor: deepOrange[500] }} />

          <Typography variant="body2" textTransform="capitalize">
            {realLegal === "Real" ? `${userProfileData.firstName} ${userProfileData.lastName}` : null}
            {realLegal === "Legal" ? `${userProfileData.firstName}` : null}
          </Typography>
        </Stack>
      ) : (
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" my={2}>
          <IconButton
            onClick={() => {
              setSelectedItem(null);
            }}
          >
            <ArrowRight color="grey.bg" size={30} />
          </IconButton>
          {selectedItem?.codeInWeb === "ChangePassword" ? (
            <Typography variant="h6" fontWeight="fontWeightMedium">
              تغییر رمز
            </Typography>
          ) : selectedItem?.codeInWeb === "AboutUs" ? (
            <Typography variant="h6" fontWeight="fontWeightMedium">
              معرفی سامانه
            </Typography>
          ) : selectedItem?.codeInWeb === "Connections" ? (
            <Typography variant="h6" fontWeight="fontWeightMedium">
              پیوندها
            </Typography>
          ) : selectedItem?.codeInWeb === "ContactUs" ? (
            <Typography variant="h6" fontWeight="fontWeightMedium">
              ارتباط با ما
            </Typography>
          ) : selectedItem?.codeInWeb === "FAQ" ? (
            <Typography variant="h6" fontWeight="fontWeightMedium">
              سوالات متداول
            </Typography>
          ) : selectedItem?.codeInWeb === "Symbols" ? (
            <Typography variant="h6" fontWeight="fontWeightMedium">
              نمادها
            </Typography>
          ) : selectedItem?.codeInWeb === "Testimonials" ? (
            <Typography variant="h6" fontWeight="fontWeightMedium">
              نظرات مشتریان
            </Typography>
          ) : null}
          <Box p={2}></Box>
        </Stack>
      )}

      <Stack alignItems="center" justifyContent="center" height="100%" width="100%" spacing={2}>
        {menu?.menu[0]?.node?.subMenus?.edges.find((i) => i.node.name === "ویرایش حساب کاربری") ? (
          !selectedItem?.id ? (
            <Button
              variant="text"
              sx={{
                p: 1,
                gap:1 ,
                "&:hover svg > path": {
                  stroke: `${theme.palette.primary.contrastText}`,
                },
              }}
              onClick={() => {
                if (realLegal === "Real" || realLegal === "Legal") {
                  addToNewTab({
                    val: "ویرایش حساب کاربری",
                    id: rundomId,
                    loading: false,
                    content:
                      realLegal === "Real"
                        ? lazy(() => import("./editprofile/EditInfoRealDialog"))
                        : realLegal === "Legal"
                          ? lazy(() => import("./editprofile/EditInfoLegalDialog"))
                          : null,
                    props: { formId: rundomId },
                  });
                  setTab(rundomId);
                }
                handleClose();
              }}
            >
              <EditIcon fontSize="small" color={theme.palette.primary.main} />
              <Typography variant="body2">{Translate.translate.buttons.edit}</Typography>
            </Button>
          ) : null
        ) : null}

        {!selectedItem?.id ? (
          <Stack width="100%" justifyContent="center" alignItems="center">
            <Grid container justifyContent="center" alignItems="center" spacing={2} width="100%">
              {menu?.menu[0]?.node?.subMenus?.edges?.map(
                (val) =>
                  val?.node?.name !== "ویرایش حساب کاربری" && (
                    <Grid
                      key={val.node.id}
                      item
                      xs={2.5}
                      {...(val?.node?.codeInWeb !== "" && val?.node?.codeInWeb !== null
                        ? {
                            onClick: () => {
                              onItemClick(val.node);
                            },
                          }
                        : undefined)}
                    >
                      <Box sx={{ width: 90, height: 90, borderRadius: 1.5 }}>
                        <Suspense>
                          {(Icon = lazy(() => import("src/components/ui/svgIcon/" + val?.node?.icon)))}
                          <TrackingCard name={val.node.name} icon={<Icon />} />
                        </Suspense>
                      </Box>
                    </Grid>
                  )
              )}
            </Grid>
          </Stack>
        ) : (
          <Stack
            width="100%"
            height="100%"
            justifyContent="flex-start"
            alignItems="center"
            bgcolor="grey.g6"
            sx={{ overflowY: "auto", maxHeight: "590px", borderRadius: 2 }}
          >
            <Grid container justifyContent="center" alignItems="center" spacing={2} width="100%" height="100%">
              <Grid item xs={12} height="100%" width="100%">
                <Stack alignItems="center" justifyContent="center" width="100%" height="100%">
                  <Stack width="100%" height="100%" spacing={2} textAlign="center" justifyContent="flex-start">
                    {selectedItem?.codeInWeb === "ChangePassword" && (
                      <Suspense>
                        {
                          (ComponentSelected = lazy(
                            () => import("src/features/AVC_Bio/components/change-password/ChangePassword")
                          ))
                        }
                        <ComponentSelected onClose={onClose}></ComponentSelected>
                      </Suspense>
                    )}
                    {selectedItem?.codeInWeb === "AboutUs" && (
                      <Suspense>
                        {(ComponentSelected = lazy(() => import("src/features/AVC_Bio/components/AboutUs")))}
                        <ComponentSelected onClose={onClose}></ComponentSelected>
                      </Suspense>
                    )}
                    {selectedItem?.codeInWeb === "Connections" && (
                      <Suspense>
                        {(ComponentSelected = lazy(() => import("src/features/AVC_Bio/components/Connections")))}
                        <ComponentSelected onClose={onClose}></ComponentSelected>
                      </Suspense>
                    )}
                    {selectedItem?.codeInWeb === "Testimonials" && (
                      <Suspense>
                        {(ComponentSelected = lazy(() => import("src/features/AVC_Bio/components/Testimonials")))}
                        <ComponentSelected onClose={onClose}></ComponentSelected>
                      </Suspense>
                    )}
                    {selectedItem?.codeInWeb === "Symbols" && (
                      <Suspense>
                        {(ComponentSelected = lazy(() => import("src/features/AVC_Bio/components/Symbols")))}
                        <ComponentSelected onClose={onClose}></ComponentSelected>
                      </Suspense>
                    )}
                    {selectedItem?.codeInWeb === "FAQ" && (
                      <Suspense>
                        {(ComponentSelected = lazy(() => import("src/features/AVC_Bio/components/faq/FAQ")))}
                        <ComponentSelected onClose={onClose}></ComponentSelected>
                      </Suspense>
                    )}
                    {selectedItem?.codeInWeb === "ContactUs" && (
                      <Suspense>
                        {(ComponentSelected = lazy(() => import("src/features/AVC_Bio/components/ContactUs")))}
                        <ComponentSelected onClose={onClose}></ComponentSelected>
                      </Suspense>
                    )}
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        )}
      </Stack>

      {false && !selectedItem?.id ? (
        <Stack alignItems="center" spacing={2} mt={2}>
          <Stack width="fit-content">
            <Button
              sx={{
                borderRadius: "50%",
                p: 1.5,
                minWidth: "unset",
                backgroundColor: (theme) => theme.palette.primary.dark,
              }}
            >
              <MedicalCallIcon />
            </Button>
          </Stack>
          <Typography variant="body2">021-88683928</Typography>
        </Stack>
      ) : null}
    </Stack>
  );
};

export default BioMenu;
